/* unplugin-vue-components disabled */import script from "./StreamDebugOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamDebugOverlay.vue?vue&type=script&setup=true&lang=js"

import "./StreamDebugOverlay.vue?vue&type=style&index=0&id=9faf77aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9faf77aa"]])

export default __exports__